<template>
  <div class="system_serve_list">
    <el-input v-model.trim="queryData.whatsAppUrl" style="width: 200px; margin: 0 20px 0 10px" placeholder="链接地址" clearable @clear="clear" />
    <el-button class="search" type="primary" @click="addchandise">添加</el-button>
    <el-button class="search" type="primary" @click="searchClk">搜索</el-button>
    <div v-for="item in tableData" :key="item.id">
      <el-collapse class="tableInfo" @change="handleChange(item)" v-model="activeNames">
        <el-collapse-item :title="item.domain + '/Jump.html?code=' + item.code" :name="item.id" class="tableInfo">
          <div class="topFunction">
            <el-button class="search" type="primary" v-clipboard:copy="item.domain + '/Jump.html?code=' + item.code" @click="copy">复制链接</el-button>
            <!-- <el-button class="search" type="info">查看数据</el-button> -->
            <!-- <el-button class="search">生成二维码</el-button> -->
            <el-button class="search" type="warning" @click="addDiversion(item)">新增分流</el-button>
            <el-button class="search" type="danger"  @click="switchClk(item,'1')" v-if="item.status == '0'">
              <span >关闭</span>
            </el-button>
            <el-button class="search" type="success" @click="switchClk(item,'0')" v-else>
              <span>开启</span>
            </el-button>
            <el-button class="search" type="warning" @click="delDiversion(item)">删除短链</el-button>
          </div>
          <el-table
            class="table"
            :data="ShortChaintableData"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            style="width: 98.5%; margin-top: 30px; margin-left: 10px"
            highlight-current-row
          >
            <el-table-column prop="id" label="id" />
            <el-table-column prop="whatsAppUrl" label="链接" />
            <el-table-column prop="whatsAppUrlStatus" label="客服状态">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.whatsAppUrlStatus" active-color="#13ce66" inactive-color="#A4B8CF" active-value="1" inactive-value="0" @change="serviceStatus(scope.row)"> </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="235">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="edeit" @click="handleEdit(scope.row)">修改</el-button>
                <el-button type="text" size="small" class="edeit" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :current-page="ShortLink.pageNum"
            :page-sizes="[10, 30, 50, 100, 200]"
            :page-size="ShortLink.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ShortLinkTotal"
            @size-change="ShortLinkHandleSizeChange($event, item)"
            @current-change="ShortLinkHandleCurrentChange($event, item)"
          />
        </el-collapse-item>
      </el-collapse>
    </div>

    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNum"
      :page-sizes="[15, 30, 50, 100, 200]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 添加弹框 -->
    <el-dialog :title="title" :visible.sync="adddialogFormVisible" width="30%" @close="handleclose">
      <el-form ref="form" :model="form" label-width="110px" class="proeditform">
        <el-form-item label="网址地址:" prop="phone" v-if="title == '添加短链'">
          <el-input v-model="form.domain" placeholder="网址地址" />
        </el-form-item>
        <el-form-item label="短链开关:" v-if="title == '添加短链'">
          <el-radio-group v-model="form.status" class="left-waidth">
            <el-radio label="0" value="0">禁用</el-radio>
            <el-radio label="1" value="1">启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="WS地址:" prop="phone" v-if="title == '添加客服链接' || title == '编辑客服链接'">
          <el-input v-model="form.whatsAppUrl" placeholder="WS地址" />
        </el-form-item>
        <el-form-item label="WS开关:" v-if="title == '添加客服链接' || title == '编辑客服链接'">
          <el-radio-group v-model="form.whatsAppUrlStatus" class="left-waidth">
            <el-radio label="0" value="0">禁用</el-radio>
            <el-radio label="1" value="1">启用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="adddialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="adddialogFormVisibleClk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from '@/utils/request'

export default {
  name: 'SystemRoles',
  components: {},
  data () {
    return {
      queryData: {
        pageNum: 1,
        pageSize: 5,
        model: {
          whatsAppUrl: ""
        }

      },
      activeNames: [],
      ShortLink: {
        pageNum: 1,
        pageSize: 10,
        model: {
          shortUrlId: ""
        }
      },
      ShortLinkTotal: 0,
      total: 0,
      tableData: [],
      ShortChaintableData: [],
      adddialogFormVisible: false,
      title: "",
      form: {
        id: "",
        domain: "",//短链
        status: "",//短链状态
        shortUrlId: "",//短链id
        whatsAppUrl: "",//	whatsapp链接
        whatsAppUrlStatus: "",//	whatsapp状态
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    handleclose () {
      this.form = {}
    },
    copy () {
      this.$message.success('复制成功')
    },
    serviceStatus (row) {
      post('/admin/shortUrlItem/update', { id: row.id, whatsAppUrlStatus: row.whatsAppUrlStatus }).then((res) => {
        if (res.data.code == 20000) {
          this.$message.success(res.data.message)
          this.ShortLinkPage()
        } else {
          this.$message.error(res.data.message)

        }

      })
    },

    handleChange (val) {
      if (this.activeNames.length > 1) {
        // 取最后一个
        const lastActiveName = this.activeNames[this.activeNames.length - 1];
        this.activeNames = [lastActiveName];
      }
      console.log(val);
      this.ShortLink.model.shortUrlId = val.id
      this.ShortLinkPage()


    },
    clear () {
      this.getList()

    },
    delDiversion (item) {
      this.$confirm('您确定要删除该短链, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post('/admin/shortUrl/delete', { id: item.id }).then((res) => {
          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.getList()

          } else {
            this.$message.error(res.data.message)

          }
        })
      })
    },
    switchClk (row,num) {
      this.$confirm('此操作将开启/关闭该短链, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = num
        post('/admin/shortUrl/update',  row).then((res) => {

          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.getList()
          } else {
            this.$message.error(res.data.message)

          }
        })
      })
    },
    addchandise () {
      this.title = '添加短链'
      this.adddialogFormVisible = true
      this.form.shortUrlId = ''

    },
    addDiversion (item) {
      this.form.id = ''
      this.title = '添加客服链接'
      this.adddialogFormVisible = true
      this.form.shortUrlId = item.id
    },
    searchClk () {
      this.getList()

    },
    handleEdit (row) {
      this.title = '编辑客服链接'
      this.adddialogFormVisible = true
      this.form.shortUrlId = row.shortUrlId
      this.form.whatsAppUrl = row.whatsAppUrl
      this.form.whatsAppUrlStatus = row.whatsAppUrlStatus
      this.form.id = row.id


    },
    handleDel (row) {
      this.$confirm('此操作将删除该客服链接, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post('/admin/shortUrlItem/delete', { id: row.id }).then((res) => {
          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.ShortLinkPage()
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    adddialogFormVisibleClk (item) {
      this.adddialogFormVisible = false
      if (this.title == '添加短链') {
        post('/admin/shortUrl/add', this.form).then((res) => {
          console.log(res.data);
          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.getList()

          } else {
            this.$message.error(res.data.message)

          }

        })
      }
      if (this.title == '添加客服链接') {
        const { status, domain, ...params } = this.form
        post('/admin/shortUrlItem/add', params).then((res) => {
          console.log(res.data);
          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.ShortLinkPage()
          } else {
            this.$message.error(res.data.message)

          }

        })
      }
      if (this.title == '编辑客服链接') {
        const { status, domain, ...params } = this.form
        post('/admin/shortUrlItem/update', params).then((res) => {
          if (res.data.code == 20000) {
            this.$message.success(res.data.message)
            this.ShortLinkPage()
          } else {
            this.$message.error(res.data.message)

          }

        })
      }


    },
    handleSizeChange (val) {
      this.queryData.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.queryData.pageNum = val
      this.getList()
    },
    ShortLinkHandleSizeChange (e, item) {

      this.ShortLink.pageSize = e
      this.ShortLink.model.shortUrlId = item.id
      this.ShortLinkPage()
    },
    ShortLinkHandleCurrentChange (e, item) {

      this.ShortLink.pageNum = e
      this.ShortLink.model.shortUrlId = item.id

      this.ShortLinkPage()

    },
    async getList () {
      const res = await post('/admin/shortUrl/page', this.queryData)
      this.total = res.data.data.total
      this.tableData = res.data.data.data

    },
    // 获取分流的分页
    async ShortLinkPage () {
      const res = await post('/admin/shortUrlItem/page', this.ShortLink)
      this.ShortLinkTotal = res.data.data.total
      this.ShortChaintableData = res.data.data.data
      return res
    }

  }
}
</script>
<style lang="scss" scoped>
.system_serve_list {
  background-color: #f7f7f7;
  padding-bottom: 50px;
}
.tableInfo {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  margin-top: 30px;
  border: 1px solid #e5e7eb;
}
.topFunction {
  display: flex;
  margin-top: 10px;
}
.el-pagination {
  width: 80%;
  display: flex;
  justify-content: flex-end;
  margin: auto;
  margin-top: 30px;
}
::v-deep .el-collapse-item__header {
  font-size: 20px;
}
</style>
